module.exports = __webpack_public_path__ + "favicon-57b818f82bcbb561e9329937928b5eb4.bundle.png";